/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import './VentaFiltersSimple.scss';

export default function VentaFiltersSimple({ listName, list, currentValue, handleChange } : {
  listName: string;
  list: any[];
  currentValue: string;
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  }) {

  if (!list) {
    return null;
  }

  return (
    <div className="VentaFiltersSimple form-group">
      <label htmlFor="selectedGrp" className=" filter-label">{listName}</label>
      <div className="input-select">
        <select name="selectedGrp" value={currentValue} onChange={handleChange}>
          <option className="select__option" key="-" value="" />
          {list.map((elem, idx) => (
            <option className="select__option" key={idx} value={elem.cod}>
              {elem.nomb}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
